<template>
  <div id="cart-page" v-if="!isNotWorking">
    <VBlock class="cart">
      <Loading :isShow="isLoading" />
      <VBlock
        v-if="!isEmptyCart"
        class="page-wrapper"
        :direction="Direction.column"
        :sort="Sort.center_center"
      >
        <CartListOptions class="cart-list-options" />
        <VBlock
          v-if="!isEmptyProduct || !isEmptySetProduct"
          :direction="Direction.column"
          :class="[!isEmptyUnpurchasableProducts && 'purchasable-products-state']"
          class="purchasable-products"
        >
          <VSection
            class="product-wrapper"
            v-if="!isEmptyProduct"
            title="일반상품"
            :size="18"
            :padding="[25, 15, 5, 15]"
          >
            <CartProducts />
          </VSection>
          <VSection
            class="product-set-wrapper"
            v-if="!isEmptySetProduct"
            title="세트상품"
            :size="18"
            :padding="[25, 15, 5, 15]"
          >
            <CartSetManyMealsProducts />
          </VSection>
        </VBlock>
        <CartUnpurchasableProducts v-if="!isEmptyUnpurchasableProducts" />
        <MoreMoveToCart />
        <CartBill />
        <VBlock :direction="Direction.column" :margin="[0, 0, 76, 0]">
          <VBlock
            v-if="isProvideDeliveryTipDiscount"
            class="info-wrapper"
            :sort="Sort.left_center"
            :padding="[20, 0, 0, 0]"
          >
            <VP
              class="info-text"
              text="배달팁 할인 이벤트는 내부사정으로 사전 예고 없이 조기 종료 될 수 있습니다."
              :size="11"
              :color="TextColor.disable"
            />
          </VBlock>

          <VBlock class="info-wrapper" :sort="Sort.left_center" :padding="[20, 0, 10, 0]">
            <VP
              class="info-text"
              text="장바구니에 담긴 상품은 최대 7일 동안 저장됩니다. 판매 종료 상품은 장바구니에서 자동으로 삭제됩니다."
              :size="11"
              :color="TextColor.disable"
            />
          </VBlock>
        </VBlock>
        <CartPaymentButton />
      </VBlock>
      <VBlock v-else class="empty-page" :direction="Direction.column" :sort="Sort.center_center">
        <VImage :type="ImageType.img" :src="resources.emptyCartImage" :width="200" :height="200" />
        <p class="empty-text">장바구니가 텅 비어있어요</p>
      </VBlock>
    </VBlock>
  </div>
</template>

<script>
import VImage, { ImageType } from '@/presentationals/v2/components/layouts/atoms/VImage'
import VP, { TextColor, TextWeight } from '@/presentationals/v2/components/layouts/atoms/VP'
import VBullet from '@/presentationals/v2/components/layouts/atoms/VBullet'

import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VSection from '@/presentationals/v2/components/layouts/molecules/VSection'

import CartListOptions from '@/presentationals/v2/components/containers/CartListOptionsContainer'
import CartProducts from '@/presentationals/v2/components/containers/CartProductsContainer'
import CartSetManyMealsProducts from '@/presentationals/v2/components/containers/CartSetManyMealsProductsContainer'
import CartUnpurchasableProducts from '@/presentationals/v2/components/containers/CartUnpurchasableProductsContainer'
import CartBill from '@/presentationals/v2/components/containers/CartBillContainer'
import Loading from '@/presentationals/v2/components/containers/LoadingContainer'
import CartPaymentButton from '@/presentationals/v2/components/containers/CartPaymentButtonContainer'
import MoreMoveToCart from '@/presentationals/v2/components/containers/MoreMoveToCartContainer'

import emptyCartImage from '@/assets/images/empty-cart@2x.png'

import { Location, MoveType } from '@/plugins/AppManager'
import { NativeStorageKey } from '@/plugins/NativeStorageManager'

import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'
import base64url from 'base64url'

import { isProvideDeliveryTipDiscount } from '../../../../config/featureProvider'

export default {
  name: 'CartPage',
  components: {
    VImage,
    VP,
    VBullet,

    VBlock,
    VSection,

    CartListOptions,
    CartProducts,
    CartSetManyMealsProducts,
    CartUnpurchasableProducts,
    CartBill,
    Loading,
    CartPaymentButton,
    MoreMoveToCart
  },
  methods: {
    setOrderState(isEmpty) {
      this.isEmpty.myOrder = isEmpty
    },
    setNonPayableOrderState(isEmpty) {
      this.isEmpty.nonPayableOrder = isEmpty
    },
    backToShop() {
      this.$appManager.move(Location.SHOP, this.$store.getters.isAndroid, MoveType.REPLACE, {
        market_cartToolTip: false,
        market_shopNo: this.$store.getters.baeminShopNo
      })
    },
    postCartViewLog() {
      const returningReformItems = (iter, product) => {
        const items = product.getItems().map(item => ({
          ItemId: String(item.id),
          ItemQty: String(item.quantity),
          ItemStatus: product.soldOut || product.disabled ? 'UNPURCHASEABLE' : 'PURCHASEABLE',
          ProductId: String(product.id)
        }))

        iter.push(...items)

        return iter
      }

      const reformPurchaseableProduct = this.$store.getters['cart/purchaseableProducts'].reduce(
        returningReformItems,
        []
      )

      const reformUnPurchaseableProduct = this.$store.getters['cart/unpurchasableProducts'].reduce(
        returningReformItems,
        []
      )

      const totalReformProductItems = [...reformPurchaseableProduct, ...reformUnPurchaseableProduct]
      const { ref, baeminShopNo } = this.$store.getters

      const params = {
        Product: totalReformProductItems,
        Ref: ref,
        ShopNo: baeminShopNo
      }

      // M1
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_CART,
        type: LogType.VIEW,
        params
      })
    }
  },
  computed: {
    isEmptyCart() {
      return (
        this.$store.state.cart.purchaseableProducts.length === 0 &&
        this.$store.state.cart.unpurchasableProducts.length === 0
      )
    },
    isProvideDeliveryTipDiscount() {
      return isProvideDeliveryTipDiscount
    },
    isUnderMinimumOrderPrice() {
      return this.$store.getters['cart/minimumOrderPrice'] > this.$store.getters['cart/totalPrice']
    },
    totalQuantity() {
      return this.$store.getters['cart/totalQuantity']
    },
    totalPrice() {
      // console.log(this.$store.getters['cart/totalQuantity'])
      return this.$store.getters['cart/totalPrice']
    },
    isEmptyProduct() {
      return this.$store.getters['cart/cartProducts'].length === 0
    },
    isEmptySetProduct() {
      return this.$store.getters['cart/cartSetProducts'].length === 0
    },
    isEmptyUnpurchasableProducts() {
      return this.$store.state.cart.unpurchasableProducts.length === 0
    }
  },
  async created() {
    const { baeminShopNo, token: accessToken, key } = this.$route.query

    await this.$store.dispatch('loadMemberByKey')
    const {
      baeminMemberId: memberId,
      baeminMemberNo: memberNo,
      sessionId,
      deviceId,
      appVersion
    } = this.$store.getters

    await this.$nativeStorageManager.set(NativeStorageKey.BAEMIN_SHOP_NO, baeminShopNo)
    await this.$nativeStorageManager.set(NativeStorageKey.ACCESS_TOKEN, accessToken || 'Guest')
    await this.$nativeStorageManager.set(NativeStorageKey.KEY, base64url.decode(key, 'utf-8'))
    await this.$nativeStorageManager.set(NativeStorageKey.SESSION_ID, sessionId)

    this.$appLogManager.init({
      memberId,
      memberNo,
      sessionId,
      deviceId,
      appVersion
    })

    const { failed, message } = await this.$store.dispatch('cart/load')
    if (failed) {
      this.isNotWorking = true

      this.$store.dispatch('modal/open', {
        type: 'Check',
        message,
        onOK: async () => {
          this.backToShop()
        },
        onCancel: async () => {}
      })
    }

    this.postCartViewLog()

    this.isLoading = false
  },
  data() {
    return {
      Direction,
      Sort,
      ImageType,
      TextColor,
      TextWeight,

      isEmpty: {
        myOrder: false,
        nonPayableOrder: false
      },

      resources: {
        emptyCartImage
      },

      isLoading: true,
      isNotWorking: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

#cart-page {
  .cart {
    .page-wrapper {
      background-color: $background-gray;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);

      .purchasable-products-state {
        margin-bottom: 10px;
        border-bottom: 1px solid $light-gray-5;
      }

      .cart-list-options {
        margin-bottom: 10px;
      }

      .purchasable-products {
        padding-bottom: 12px;
        background-color: $white;

        .product-wrapper {
          width: 100%;
          box-sizing: border-box;
        }

        .product-set-wrapper {
          width: 100%;
          box-sizing: border-box;
          padding-top: 20px;
        }
      }

      .info-wrapper {
        position: relative;
        width: 100%;
        height: auto;
        box-sizing: border-box;

        .info-text {
          padding-left: 18px;
          padding-right: 18px;
          text-align: left;
        }
      }
    }

    .empty-page {
      width: 100vw;
      height: 100vh;
      background-color: $white;

      .empty-text {
        text-align: center;
        letter-spacing: -0.3px;
        font-size: 16px;
        line-height: 1;
        color: $gray-2;
        margin-top: 12px;
      }
    }
  }
}
</style>
